import { z } from 'zod';
import { baseComponentSchema } from '../component-base.schemas';

export const footerLinkSchema = z.object({
  text: z.string().min(1, 'Link text is required'),
  url: z.string().min(1, 'Link URL is required'),
  category: z.string().optional(),
});

// Footer custom colors schema - allows overriding theme colors per component instance
export const footerCustomColorsSchema = z
  .object({
    background: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    text: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    mutedText: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
    linkHover: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
  })
  .optional();

export const footerDataSchema = z.object({
  siteName: z.string().min(1, 'Site name is required'),
  description: z.string().optional(),
  links: z.array(footerLinkSchema).default([]),
  socialLinks: z
    .array(
      z.object({
        platform: z.string().min(1, 'Platform is required'),
        url: z.string().url('Invalid URL'),
      })
    )
    .default([]),
  copyright: z.string().optional(),
  // DEPRECATED: Use customColors.background instead (kept for backward compatibility)
  backgroundColor: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/)
    .optional(),
  // DEPRECATED: Use customColors.text instead (kept for backward compatibility)
  textColor: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/)
    .optional(),
  // NEW: Component-specific custom colors that override theme colors
  customColors: footerCustomColorsSchema,
});

export const footerComponentSchema = baseComponentSchema.extend({
  type: z.literal('footer'),
  data: footerDataSchema,
});

// Type exports
export type FooterLink = z.infer<typeof footerLinkSchema>;
export type FooterData = z.infer<typeof footerDataSchema>;
export type FooterComponent = z.infer<typeof footerComponentSchema>;
